/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IProxyControlled,
  IProxyControlledInterface,
} from "../IProxyControlled";

const _abi = [
  {
    inputs: [],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation_",
        type: "address",
      },
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IProxyControlled__factory {
  static readonly abi = _abi;
  static createInterface(): IProxyControlledInterface {
    return new Interface(_abi) as IProxyControlledInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IProxyControlled {
    return new Contract(address, _abi, runner) as unknown as IProxyControlled;
  }
}
